import { SxProps, Theme } from "@mui/material";

export type DropTarget = {
  id: string;
  position: "before" | "after";
} | null;

const DROP_INDICATOR_COLOR = "3px solid rgba(25, 118, 210, 0.65)";

export const getVerticalDropPosition = (
  clientY: number,
  rect: DOMRect,
): "before" | "after" => {
  const midpoint = rect.top + rect.height / 2;
  return clientY < midpoint ? "before" : "after";
};

export const getHorizontalDropPosition = (
  clientX: number,
  rect: DOMRect,
): "before" | "after" => {
  const midpoint = rect.left + rect.width / 2;
  return clientX < midpoint ? "before" : "after";
};

export const getDropIndicatorRowSx = (
  readOnly: boolean,
  isDragging: boolean,
  isBeforeTarget: boolean,
  isAfterTarget: boolean,
): SxProps<Theme> => ({
  cursor: readOnly ? "default" : "grab",
  opacity: isDragging ? 0.6 : 1,
  "& > td": {
    borderTop: isBeforeTarget ? DROP_INDICATOR_COLOR : undefined,
    borderBottom: isAfterTarget ? DROP_INDICATOR_COLOR : undefined,
  },
});
